module.exports = __webpack_public_path__ + "gg.svg?cfca4d1d56a7247865d787046bf0f23e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gg.svg
// module id = 1007
// module chunks = 27